import * as libRegions from '@luxuryescapes/lib-regions';

// getAllCurrencyCodes returns all possible values for currency codes
export default function (): Array<string> {
  const regions = libRegions.getRegions();
  return Array.from(new Set(regions.map((region) => region.currencyCode).sort()).values());
}
